import React, { useEffect, useState } from 'react';
import { resolveWebImageSrc } from '../../utils/resolveMediaUrl';

function initialsFromName(name: string): string {
  const n = (name || '').trim();
  if (!n) return '?';
  return n.charAt(0).toUpperCase();
}

export interface ProfileAvatarProps {
  name: string;
  /** API shape: string URL, `{ url }`, or empty */
  photo?: unknown;
  className?: string;
}

/**
 * Shows a profile image when a real URL resolves; otherwise a single-letter
 * initials placeholder (same convention as the client dashboard header).
 */
const ProfileAvatar: React.FC<ProfileAvatarProps> = ({ name, photo, className = '' }) => {
  const [imgFailed, setImgFailed] = useState(false);
  const src = resolveWebImageSrc(photo ?? '');
  const showImg = Boolean(src) && !imgFailed;

  useEffect(() => {
    setImgFailed(false);
  }, [src]);
  const label = (name || '').trim() || 'User';

  return (
    <div className={className} role="img" aria-label={label}>
      {showImg ? (
        <img src={src} alt="" onError={() => setImgFailed(true)} />
      ) : (
        <span className="avatar-initials" aria-hidden="true">
          {initialsFromName(label)}
        </span>
      )}
    </div>
  );
};

export default ProfileAvatar;
